import { ColumnViewModel } from '../../shared/column-types';

export const GENES_ALL: ColumnViewModel = {
  columns: [
    'symbol',
    'description',
    'ncbiID',
    'gene_ensembl_id',
    'proteinIDs',
    'proteinClassIDs',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'ncbi_type',
    'nct_id',
    'pathwayName',
    'pathwayID',
    'numChemicals',
    'DSI',
    'DPI',
    'PLI',
    'numPublications',
    'numCTs',
    'numberPmidsWithChemsIncludedInEvidence',
    'firstRef',
    'lastRef',
  ],
  defaultVisible: [
    'symbol',
    'description',
    'proteinClassIDs',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'numChemicals',
    'DSI',
    'DPI',
    'PLI',
    'numPublications',
    'numCTs',
    'firstRef',
    'lastRef',
  ],
};